import React, { forwardRef } from 'react';
import { Button } from 'ssc-ui-react';
import { UploadFile } from 'ssc-ui-react/typings/components/upload/types';

import { createFileUpload } from '@/utils/fileUpload';

import { BatchImportResData, BatchImportResItem } from '../type';

type BatchImportButtonProps = {
  onSuccess: (response?: BatchImportResData<BatchImportResItem>, file?: UploadFile) => void;
  uploadReq: (data: any) => Promise<any>;
  onError: () => void;
}

const uploadFile = async () => {
  try {
    const file = await createFileUpload();
    const formData = new FormData();
    formData.append('excel_file', file);
    return formData;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const BatchImportButton = forwardRef((props: any | BatchImportButtonProps, ref: any) => {
  const { text, onError, onSuccess, uploadReq } = props;
  const handleClick = async () => {
    try {
      const formData = await uploadFile();
      if (!formData) return;
      const res = await uploadReq(formData);
      onSuccess(res);
    } catch (e) {
      console.log('err', e);
      onError(e);
    }
  };
  return (
    <Button type="primary" onClick={handleClick}>
      <span ref={ref}>{text}</span>
    </Button>
  );
});
export default BatchImportButton;
